<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="基地名称：" prop="baseName">
            <el-input style="width: 424px;" v-model="ruleForm.baseName" placeholder="请输入基地名称"></el-input>
          </el-form-item>
          <el-form-item label="基地图片：" prop="baseImg">
            <el-upload
              :action="baseUrl+'/system/common/upload/uploadFile'"
              list-type="picture-card"
              :headers="{'Authorization': token}"
              :multiple="false"
              :limit="1"
              :file-list="fileList"
              :on-remove="delImgBtn"
              :on-success="bannerImgBtn">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">若需要更换图片，请先删除原图片</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="联系电话：" prop="basePhone">
            <el-input style="width: 424px;" v-model="ruleForm.basePhone" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="基地介绍：" prop="baseText">
            <editor :height="350" v-model="ruleForm.baseText"></editor>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item v-if="dataId == ''" label="用户账号：" prop="userName">
            <el-input style="width: 424px;" v-model="ruleForm.userName" placeholder="请输入用户账号" :disabled="dataId == '' ? false : true"></el-input>
          </el-form-item>
          <el-form-item v-if="dataId == ''" label="密码：" prop="userPassword">
            <el-input style="width: 424px;" type="password" show-password v-model="ruleForm.userPassword" placeholder="请输入用户密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { saveSeleniumJourneyBase, fetchSeleniumJourneyBaseDetailById, updateSeleniumJourneyBase } from '@/api/xyj'
import Editor from '@/components/Editor.vue'
export default {
  name: 'BasesAdd',
  components: {
    Editor
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      dataId: this.$route.query.dataId,
      fileList:[],
      ruleForm: {
        baseName: '',
        baseImg:'',
        basePhone: '',
        baseText: '',
        status: false,
        userName: '',
        userPassword: ''
      },
      rules: {
        baseName: [
          { required: true, message: '请输入基地名称', trigger: 'blur' }
        ],
        baseImg: [
          { required: true, message: '请上传基地图片', trigger: 'blur' }
        ],
        basePhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入用户账号', trigger: 'blur' }
        ],
        userPassword: [
          { required: true, message: '请输入用户密码', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    if (this.$route.query.dataId != ''){
      let that = this
      fetchSeleniumJourneyBaseDetailById({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.baseName = data.baseName
          let status = false
          if (data.status === 1) {
            status = true
          }
          that.ruleForm.status = status
          that.ruleForm.baseImg = data.baseImg
          if(data.baseImg != null){
            that.fileList.push({url: data.baseImg})
          }
          that.ruleForm.basePhone = data.basePhone
          that.ruleForm.baseText = data.baseText
        }
      })
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    bannerImgBtn (file) {
      this.ruleForm.baseImg = file.data.fileUrl
    },
    /* 删除上传的图片 */
    delImgBtn(file,fileList){
      var imgUrl = '';
      fileList.forEach(function(item){
        imgUrl = item.url;
      });
      this.ruleForm.baseImg = imgUrl;
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let baseName = that.ruleForm.baseName
      let baseImg = that.ruleForm.baseImg
      let basePhone = that.ruleForm.basePhone
      let baseText = that.ruleForm.baseText
      let status = that.ruleForm.status ? 1 : 0
      let userName = that.ruleForm.userName
      let userPassword = that.ruleForm.userPassword
      if (baseName === '') {
        this.$message.error('请输入基地名称')
        return false
      }
      if (baseImg === '') {
        this.$message.error('请上传基地图片')
        return false
      }
      if (basePhone == '') {
        this.$message.error('请输入联系电话')
        return false
      }
      if (userName == '' && dataId == '') {
        this.$message.error('请输入用户账号')
        return false
      }
      if (userPassword == '' && dataId == '') {
        this.$message.error('请输入用户密码')
        return false
      }
      let passData = {
        baseName: baseName, baseImg: baseImg, basePhone: basePhone, status: status, baseText: baseText, userName: userName, userPassword: userPassword
      }
      if (dataId !== '') {
        passData.id = dataId;
        updateSeleniumJourneyBase(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        saveSeleniumJourneyBase(passData).then((res) => {
         that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xyj/BasesAdd.vue